import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiinternatinalairportcab() {



const cardData =
{
  keyword: 'Navi Mumbai International Airport Cabs',

  heading: 'Lotus Cab: Navi Mumbai International Airport Cabs',

headingDescription:
    "Lotus Cabs provides reliable and affordable Navi Mumbai International Airport Cabs for domestic and international airport transfers, corporate travel, hotel transfers, railway station pickups, family travel, business meetings, sightseeing tours, outstation journeys, and one-way or round-trip bookings. We offer a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, real-time flight tracking, transparent pricing, doorstep pickup and drop, well-maintained vehicles, and punctual service, Lotus Cabs ensures a smooth, comfortable, and hassle-free airport transfer experience to and from Navi Mumbai International Airport (NMIA). Whether you are arriving for business or leisure, our professional drivers and premium fleet guarantee safe, reliable, and comfortable transportation every time.",

  top: 'Top Nearby Locations Connected to Navi Mumbai International Airport with Lotus Cab',

  topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most frequently booked destinations from Navi Mumbai International Airport, attracting business travelers, students, corporate professionals, tourists, and families throughout the year. Lotus Cabs offers comfortable airport transfers via the Mumbai–Pune Expressway with professional chauffeurs, spacious vehicles, and reliable door-to-door service, ensuring a relaxing journey to any location in Pune."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station famous for Bhushi Dam, Tiger Point, Karla Caves, Rajmachi Fort, waterfalls, and lush green valleys. Travelers arriving at Navi Mumbai International Airport often choose Lotus Cabs for direct transfers to this popular weekend destination, enjoying breathtaking mountain views and a comfortable ride through the Western Ghats."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most sacred pilgrimage destinations and welcomes millions of Sai Baba devotees every year. Lotus Cabs provides dependable Navi Mumbai International Airport to Shirdi cab services with experienced chauffeurs, clean vehicles, and flexible one-way or round-trip options, making every pilgrimage peaceful, convenient, and comfortable."
    },
    {
        title: "Nashik",
        description:
            "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, Ram Kund, Sula Vineyards, and the Kumbh Mela. Whether you are visiting for pilgrimage, business, wine tourism, or family holidays, Lotus Cabs offers safe and reliable airport taxi services from Navi Mumbai International Airport directly to Nashik with complete travel comfort."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most beautiful hill stations, famous for Venna Lake, Arthur's Seat, strawberry farms, waterfalls, and scenic mountain viewpoints. Travelers arriving at Navi Mumbai International Airport can enjoy a relaxing road trip with Lotus Cabs while experiencing premium comfort and dependable long-distance travel."
    },
    {
        title: "Goa",
        description:
            "Goa is India's most popular beach destination, offering pristine beaches, Portuguese heritage, luxury resorts, vibrant nightlife, churches, forts, and exciting water sports. Lotus Cabs provides comfortable long-distance airport cab services from Navi Mumbai International Airport to Goa, making family vacations, honeymoon trips, and group holidays enjoyable and completely hassle-free."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a favorite coastal getaway known for Alibaug Beach, Kolaba Fort, Kashid Beach, beach resorts, and adventure water sports. Located within easy driving distance from Navi Mumbai International Airport, it is an ideal destination for travelers seeking a relaxing beach holiday with convenient and comfortable transportation provided by Lotus Cabs."
    },
    {
        title: "Aurangabad (Chhatrapati Sambhajinagar)",
        description:
            "Aurangabad is home to UNESCO World Heritage Sites including Ajanta Caves and Ellora Caves, along with Grishneshwar Jyotirlinga, Daulatabad Fort, and Bibi Ka Maqbara. Lotus Cabs offers reliable airport taxi services from Navi Mumbai International Airport, making heritage tours, religious pilgrimages, and family vacations comfortable and memorable."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is renowned for the sacred Mahalaxmi Temple, Panhala Fort, Rankala Lake, and authentic Maharashtrian cuisine. Whether you are traveling for pilgrimage, business, or leisure, Lotus Cabs provides safe and comfortable long-distance transfers from Navi Mumbai International Airport with professional drivers and premium vehicles."
    },
    {
        title: "Matheran",
        description:
            "Matheran is Asia's only automobile-free hill station and is famous for its panoramic viewpoints, heritage toy train, lush forests, pleasant climate, and tranquil surroundings. Travelers arriving at Navi Mumbai International Airport frequently book Lotus Cabs for convenient transfers to Matheran, enjoying a peaceful escape into nature with a smooth and comfortable journey."
    }
],

  "services": [
    {
      "name": "Navi Mumbai International Airport Cab Service",
      "description": "Book Navi Mumbai International Airport cab service for reliable airport pickup and drop across Navi Mumbai, Mumbai, Thane, and Pune. Available 24x7 with AC sedan, Ertiga, Innova Crysta, SUV, and luxury vehicle categories. Drivers monitor flight schedules to adjust pickup timing and avoid unnecessary waiting charges. Transparent per km pricing or fixed airport fare options are provided depending on destination. Fare includes toll charges and parking details for complete clarity. Suitable for individual travelers, families with luggage, corporate executives, and business delegations."
    },
    {
      "name": "NMIA Airport Pickup Taxi",
      "description": "Professional airport pickup taxi service at NMIA ensures driver arrival before landing time with name board assistance. Luggage support and smooth navigation through airport terminals ensure hassle-free exit. Ideal for corporate guests and first-time visitors."
    },
    {
      "name": "NMIA Airport Drop Cab",
      "description": "Timely airport drop cab service to NMIA with route optimization to avoid traffic congestion. Early morning and late-night departures are supported with 24x7 availability."
    },
    {
      "name": "Prepaid Cab at NMIA",
      "description": "Prepaid airport cab option with upfront fare transparency. Customers receive clear billing structure without hidden charges."
    },
    {
      "name": "Corporate Cab Service NMIA",
      "description": "Corporate cab services with monthly billing options for companies requiring frequent airport transfers for employees and clients."
    },
    {
      "name": "Innova Cab at NMIA",
      "description": "Premium Innova Crysta airport cab suitable for families and executive travel requiring extra luggage capacity and comfort."
    },
    {
      "name": "Ertiga & Sedan Taxi NMIA",
      "description": "Budget-friendly Ertiga and sedan taxi options for economical airport transfers."
    },
    {
      "name": "Luxury & SUV Cab NMIA",
      "description": "Luxury and SUV airport cab service offering executive comfort for VIP and business-class travelers."
    }
  ],

  "tableData": [
    ["Navi Mumbai International Airport Cab Service", "NMIA Airport Pickup Taxi"],
    ["NMIA Airport Drop Cab", "Prepaid Cab at NMIA"],
    ["Corporate Cab Service NMIA", "Innova Cab at NMIA"],
    ["Ertiga & Sedan Taxi NMIA", "Luxury & SUV Cab NMIA"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "24x7 Airport Availability",
      "WhyChoosedescription": "Round-the-clock NMIA cab service for early and late flight schedules."
    },
    {
      "WhyChooseheading": "Flight Monitoring Support",
      "WhyChoosedescription": "Real-time flight tracking prevents waiting delays and extra charges."
    },
    {
      "WhyChooseheading": "Transparent Fare Structure",
      "WhyChoosedescription": "Clear per km or fixed airport pricing with toll and parking details."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs",
      "WhyChoosedescription": "Trained drivers familiar with airport terminals and city routes."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Categories",
      "WhyChoosedescription": "Sedan, Ertiga, Innova, SUV, and luxury options available."
    },
    {
      "WhyChooseheading": "Corporate Billing Options",
      "WhyChoosedescription": "Monthly billing for companies and frequent business travelers."
    },
    {
      "WhyChooseheading": "Safe & Comfortable Travel",
      "WhyChoosedescription": "Well-maintained AC vehicles ensure smooth airport transfers."
    },
    {
      "WhyChooseheading": "Area-Wide Pickup Coverage",
      "WhyChoosedescription": "Pickup available across Navi Mumbai, Thane, Mumbai, and Pune."
    }
  ]
}














const faqData = [
  {
    question: 'Does Lotus Cab provide Navi Mumbai International Airport cab service?',
    answer: 'Yes, Lotus Cab offers reliable Navi Mumbai International Airport cab services for timely pickup and drop with professional drivers and well-maintained vehicles.',
  },
  {
    question: 'Is airport pickup available from Navi Mumbai International Airport?',
    answer: 'Yes, Lotus Cab provides airport pickup service with real-time flight tracking to ensure timely arrival even if your flight is delayed.',
  },
  {
    question: 'What are the charges for Navi Mumbai International Airport cabs?',
    answer: 'Cab charges depend on pickup or drop location, distance, vehicle type, and travel time. Lotus Cab offers transparent pricing with no hidden charges.',
  },
  {
    question: 'Is 24/7 airport cab service available?',
    answer: 'Yes, Lotus Cab operates 24/7 airport cab services for Navi Mumbai International Airport including early morning and late-night flights.',
  },
  {
    question: 'Which vehicles are available for airport transfers?',
    answer: 'We provide Sedan cars like Dzire and Etios for individual travelers and SUVs like Ertiga and Innova Crysta for family and group airport transfers.',
  },
  {
    question: 'Do drivers assist with luggage at the airport?',
    answer: 'Yes, our professional drivers provide luggage assistance to ensure a smooth and comfortable airport transfer experience.',
  },
  {
    question: 'Are toll and parking charges included in airport cab fare?',
    answer: 'Toll and parking charges are billed separately as per actuals. Lotus Cab ensures complete fare transparency before confirming your booking.',
  },
  {
    question: 'Can I book a round trip airport cab service?',
    answer: 'Yes, you can book both pickup and return airport transfers in advance with flexible scheduling options.',
  },
  {
    question: 'Is corporate airport transfer available at Navi Mumbai International Airport?',
    answer: 'Absolutely. Lotus Cab provides punctual and professional airport transfer services for corporate clients and business travelers.',
  },
  {
    question: 'How can I book Navi Mumbai International Airport cab with Lotus Cab?',
    answer: 'You can book by sharing your pickup or drop location, flight details, travel date, and vehicle preference to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Kulkarni',
    feedback: 'Booked Lotus Cab for Navi Mumbai International Airport pickup. Driver tracked our flight and arrived on time. Very smooth experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Mehta',
    feedback: 'Excellent airport cab service. Clean vehicle, professional driver, and transparent pricing. Highly recommend Lotus Cab.',
    rating: 5,
  },
];

















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai International Airport Cab",
"image": "https://lotuscab.com/assets/images/navi-mumbai-international-airport-cab.jpg",
"description": "Book Navi Mumbai International Airport Cab with Lotus Cab for safe, reliable, and comfortable airport transfers. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "8650"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹12/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/navi-mumbai-international-airport-cab"
}
};












  return (
    <div>
      

<Helmet>
  <title>Navi Mumbai International Airport Cab | 24x7 Airport Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Navi Mumbai International Airport Cab with Lotus Cab for reliable airport pickup and drop. 24x7 taxi service with Sedan, SUV, and AC cabs, professional drivers, and instant booking confirmation for stress-free travel."
/>

<meta
 name="keywords"
 content="Navi Mumbai International Airport Cab, NMIA Cab Service, Navi Mumbai Airport Taxi, Airport Cab Navi Mumbai, Navi Mumbai Airport Pickup Cab, Navi Mumbai Airport Drop Cab, International Airport Cab Mumbai, NMIA Taxi Service, Airport Transfer Navi Mumbai, Cheap Airport Cab Navi Mumbai, Best Airport Taxi Navi Mumbai, Online Airport Cab Booking, Sedan Airport Cab, SUV Airport Cab, Lotus Cab Airport Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiinternatinalairportcab;